import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=bbb657b0&scoped=true"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=bbb657b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb657b0",
  null
  
)

export default component.exports